import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeInternalStorage extends Shape {
    width = 200;
    height = 140;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        let gap = height / 16;

        gap = width / 16 < gap ? gap : width / 16;

        const allowedWidth = width - gap - 2 * horizontalPadding;
        const allowedHeight = height - gap - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + gap + (width - gap) / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, verticalPadding, null, gap);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 30;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.closePath();

        const gapH = h * 0.22;
        const gapW = w * 0.2;

        canv.ctx.moveTo(x, y + gapH);
        canv.ctx.lineTo(x + w, y + gapH);

        canv.ctx.moveTo(x + gapW, y);
        canv.ctx.lineTo(x + gapW, y + h);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M5.6178 4v16M.5 8.1665h23M2.361 4.463h19.5407c.7708 0 1.3957.6218 1.3957 1.3889v12.4989c0 .767-.6249 1.3888-1.3957 1.3888H2.3611c-.7709 0-1.3958-.6218-1.3958-1.3888V5.8518c0-.767.625-1.3888 1.3958-1.3888Z"/>
            </svg>
        `;
    }
}
